'use client';

import React from 'react';
import Box from '../../../atoms/Box/Box';
import Row from '../../../atoms/Grid/Row/Row';
import Iconography from '../../../atoms/Iconography/Iconography';
import IconButton from '../../../atoms/IconButton/IconButton';

import styles from './Header.module.scss';

interface HeaderProps {
  isExpanded: boolean;
  isCollapsed: boolean;
  isHovered: boolean;
  theme: 'light' | 'dark';
  onHamburgerClick: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isExpanded,
  isCollapsed,
  isHovered,
  theme,
  onHamburgerClick,
}) => {
  const iconColor = theme === 'dark' ? 'white' : 'black';

  return (
    <Box className={styles.header} pt={24} pb={24}>
      <Row
        gutter={[0, 0]}
        justify={isCollapsed && !isHovered ? 'center' : 'space-between'}
        align="middle"
        wrap={false}
      >
        <div className={styles.logoGroup}>
          {isExpanded ? (
            <>
              <Iconography category="brand" name="logo" color={iconColor} size={32} />
              <Iconography category="brand" name="bear" color={iconColor} size={32} />
            </>
          ) : (
            <Iconography category="brand" name="lucid-logo" color={iconColor} size={32} />
          )}
        </div>
        {isExpanded && (
          <IconButton
            icon={{ category: 'global', name: 'hamburger' }}
            variant="button"
            buttonType="tertiary"
            theme={theme}
            size="medium"
            gaComponent="sidebar-hamburger"
            dataTestId="hamburger-menu-button"
            handleClick={onHamburgerClick}
          />
        )}
      </Row>
    </Box>
  );
};

Header.displayName = 'Header';

export default Header;
